import { ButtonBase } from "@mui/material";
import { useTranslations } from "use-intl";

import { IconGreenPlus } from "@/components/Icons";

interface Props {
  servicesSelectedCount?: number;
  onClick: () => void;
}

export const SelectedAdditionalServicesCard = ({
  servicesSelectedCount,
  onClick,
}: Props) => {
  const t = useTranslations();

  return (
    <ButtonBase
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "start",
        gap: "calc(var(--spacing) * 2)",
        borderRadius: "var(--radius-2xl)",
        backgroundColor: "var(--color-surface-neutral-soft)",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "var(--color-surface-neutral-medium)",
        padding: "calc(var(--spacing) * 3)",
        textAlign: "start",
        fontSize: "var(--text-sm)",
        fontWeight: "var(--font-weight-medium)",
      }}
      onClick={onClick}
    >
      <IconGreenPlus />
      <div className="flex flex-col gap-0.5">
        <div className="text-black">{t("travellers.additionalServices")}</div>
        {servicesSelectedCount ? (
          <div className="text-core-accent-500">
            {t("travellers.xServicesSelected", {
              count: servicesSelectedCount,
            })}
          </div>
        ) : (
          <div className="text-text-tertiary">
            {t("travellers.noServicesSelected")}
          </div>
        )}
      </div>
      <div className="my-auto ms-auto leading-5 font-bold text-text-interactive">
        {servicesSelectedCount ? t("edit") : t("add")}
      </div>
    </ButtonBase>
  );
};
